import React from 'react'
import DownloadSvg from 'images/modules/Shared/i-download.svg?raw'

export { default as DownloadUrl } from 'images/modules/Shared/i-download.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: DownloadSvg}} />
)
